export default __webpack_public_path__ + "static/media/weather.721d9d31.jpg";